// Campus photo for /colleges/texas-tech-university: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATexas_Tech_University_April_2022_23_(Memorial_Circle_and_Administration).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/texas-tech-university/; credited under the photo.
const photo = {
    "slug": "texas-tech-university",
    "alt": "The Administration Building and Memorial Circle on the Texas Tech University campus in Lubbock, Texas",
    "src": "/colleges/texas-tech-university/campus-1600.webp",
    "srcSmall": "/colleges/texas-tech-university/campus-800.webp",
    "srcMid": "/colleges/texas-tech-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/texas-tech-university/og.jpg",
    "title": "Texas Tech University April 2022 23 (Memorial Circle and Administration)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATexas_Tech_University_April_2022_23_(Memorial_Circle_and_Administration).jpg",
    "read": "2026-10-01"
};

export default photo;
